import { Grey1, Grey9, Grey10 } from "styles/antTheme/Colors";
import { ColorPickerConstants } from "styles/buildertrendTheme/Colors";
import tinycolor from "tinycolor2";

const nonCompliantBackgroundColors = [
    ColorPickerConstants.Peach,
    ColorPickerConstants.Green,
    ColorPickerConstants.Ice,
    ColorPickerConstants.AlarmPink,
    ColorPickerConstants.Gray,
];

export function getCompliantTextColor(bgColor: string) {
    // map specific non-compliant colors to grey-10 for accessibility
    if (nonCompliantBackgroundColors.includes(bgColor)) {
        return Grey10;
    }

    return tinycolor(bgColor).isDark() ? Grey1 : Grey9;
}
